import { InjectionToken, Provider } from '@angular/core';
import { TollingRepository } from '../../domain/tolling.repository';
import { TollingService } from '../tolling/tolling.service';

export const TOLLING_REPOSITORY = new InjectionToken<TollingRepository>('TollingRepository');

export const TOLLING_API_PROVIDER: Provider = {
    provide: TollingRepository,
    useClass: TollingService,
};
